// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1_rGF","cls2":"FocusedNav-cls2_Yo0 FocusedNav-cls1_rGF"};